import FormSelect from 'components/Select/FormSelect';
import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetCategoriesShort, IGetCategoriesShortResponse, ITotalPrice } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesShortInfo } from 'backend/categories';

interface ISuggestedDishCategorySelect {
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
	setSuggestedDishCategory: (value: Nullable<string>) => void;
	totalPrices: ITotalPrice[];
}

const SuggestedDishCategorySelect: React.FC<ISuggestedDishCategorySelect> = ({
	setFetchedCategories,
	setSuggestedDishCategory,
	totalPrices,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(totalPrices.length ? getCategoriesShortInfo : null, { restaurantIds: totalPrices.map((el) => el.restaurantId) });

	useEffect(() => {
		refetch();
	}, [totalPrices]);

	useEffect(() => {
		response && setFetchedCategories(response.data.categories);
	}, [response]);

	return (
		<FormSelect
			name="selectedSuggestedDishCategory"
			label="categoryLabel"
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={!totalPrices.length || loading}
			onChange={setSuggestedDishCategory}
		/>
	);
};

export default React.memo(SuggestedDishCategorySelect);
